module.exports = __webpack_public_path__ + "img/1409261477.301c3f05.jpg";